import * as echarts from 'echarts';

import CanvasHandler from './CanvasHandler';

class ChartHandler {
    canvasHandler?: CanvasHandler;
    instance?: echarts.ECharts;

    constructor(canvasHandler: CanvasHandler) {
        this.canvasHandler = canvasHandler;
    }
}

export default ChartHandler;
